import Vue from 'vue'
//import util from '@/js/Util'

function setDotIndex(state, value) {
  Vue.set(state.currentReads, 'dotIndex', value)
}

function meterDataReceived(state, data) {
  let current = data.lastMinute.power

  Vue.set(state.currentReads, 'balance', current.balance)

  // According to Fritz, the backend makes sure that either toGrid or
  // fromGrid is > 0 but never both.
  Vue.set(state.currentReads, 'toGrid', Math.abs(current.toGrid))
  Vue.set(state.currentReads, 'fromGrid', Math.abs(current.fromGrid))
  Vue.set(state.currentReads, 'fromCommunity', Math.abs(current.fromCommunity))
  Vue.set(state.currentReads, 'fromSupplier', Math.abs(current.fromSupplier))
  Vue.set(state.currentReads, 'toCommunity', Math.abs(current.toCommunity))
  Vue.set(state.currentReads, 'toSupplier', Math.abs(current.toSupplier))
  Vue.set(
    state.currentReads,
    'communityConsumable',
    Math.abs(current.communityConsumable)
  )
  Vue.set(
    state.currentReads,
    'communityShareable',
    Math.abs(current.communityShareable)
  )

  let dotIndex = Math.round(current.balance / state.currentReads.wattsPerDot)
  if (dotIndex > 5) {
    dotIndex = 6
  }
  if (dotIndex < -5) {
    dotIndex = -6
  }
  Vue.set(state.currentReads, 'dotIndex', dotIndex)
}

function dotPositionsUpdated(state, coordinates) {
  Vue.set(state.currentReads, 'dotCoordinates', coordinates)
}

function onCubeConnectionEstablished(state) {
  if (state.currentReads.backendMeterDataInterval) {
    clearInterval(state.currentReads.backendMeterDataInterval)
  }
}

/**
 *
 * @param state
 * @param intervalId
 *  The result of window.setInterval
 */
function onCubeConnectionLost(state, intervalId) {
  state.currentReads.isCubeReachable = false
  if (intervalId) {
    // Only update the intervalId if we get a valid id and clear any existing
    // intervals.
    if (state.currentReads.backendMeterDataInterval) {
      window.clearInterval(state.currentReads.backendMeterDataInterval)
    }
    Vue.set(state.currentReads, 'backendMeterDataInterval', intervalId)
  }
}

export default {
  meterDataReceived,
  setDotIndex,
  dotPositionsUpdated,
  onCubeConnectionLost,
  onCubeConnectionEstablished,
}
